import React from 'react';

export function useFancyState<T>(initState: T) {
    const [state, setStates] = React.useState<T>(initState);

    const setMultipleState = React.useCallback(
        (newPartialState: Partial<T>) => {
            return setStates(oldState => ({ ...oldState, ...newPartialState }));
        },
        [setStates]
    );

    const setState = React.useCallback(
        (key: keyof T, value: T[keyof T]) => {
            setMultipleState({ [key]: value } as Partial<T>);
        },
        [setMultipleState]
    );

    return { state, setState, setMultipleState };
}
